
export const MedTermsAndConditions = () => {
	return (
		<div>
<h2>Términos de uso – Registro de Profesionales de la Salud</h2>

<p><strong>Kaiteki</strong></p>

<p><strong>Última actualización:</strong> 30/12/2025</p>

<p>
Al registrarse y utilizar Kaiteki, el profesional de la salud acepta las siguientes condiciones:
</p>

<p>
Kaiteki es una plataforma digital que facilita la atención médica a distancia entre profesionales y pacientes. La Plataforma no presta servicios médicos ni interviene en las decisiones clínicas.
</p>

<p>
La relación entre Kaiteki y el profesional se establece como una prestación de servicios independiente. No existe relación laboral, subordinación, exclusividad ni obligación de permanencia.
</p>

<p>
El profesional es el único responsable del acto médico realizado, incluyendo diagnóstico, indicaciones, prescripción y seguimiento del paciente, conforme a las normas éticas y legales vigentes.
</p>

<p>
El servicio no está destinado a situaciones de urgencia o emergencia. Ante casos que lo requieran, el profesional deberá indicar al paciente la necesidad de atención presencial o concurrencia a un servicio de guardia.
</p>

<p>
El profesional se compromete a resguardar la confidencialidad de los datos del paciente y a registrar la información clínica de manera responsable en la historia clínica digital compartida de la Plataforma, conforme a la Ley N° 25.326.
</p>

<p>
De manera excepcional, algunas consultas podrán ser grabadas con fines de control de calidad y seguridad, previa información y consentimiento del profesional y del paciente.
</p>

<p>
Los honorarios por consulta serán informados previamente. El profesional percibe sus honorarios a través del sistema de pago habilitado en la Plataforma y es responsable de la emisión del comprobante fiscal correspondiente al paciente.
</p>

<p>
Tanto Kaiteki como el profesional podrán finalizar la vinculación en cualquier momento, sin penalidades, mediante notificación electrónica.
</p>

<p>
<strong>El profesional declara haber leído, comprendido y aceptado estos Términos de Adhesión para Profesionales de la Salud de Kaiteki.</strong>
</p>
		</div>
	)
}

// Cuando se Registra un Paciente
export const AppTermsAndConditions = () => {
	return (
		<div>
<h2>TÉRMINOS DE USO – REGISTRO DE PACIENTES</h2>

<p><strong>Última actualización:</strong> 30/12/2025</p>

<p>
Al registrarse como paciente en Kaiteki, el usuario declara haber leído y aceptar las siguientes condiciones:
</p>

<p>
Kaiteki es una plataforma digital que facilita la vinculación y coordinación de consultas médicas entre pacientes y profesionales de la salud. Kaiteki no brinda atención médica directa ni reemplaza la consulta presencial cuando esta resulte necesaria.
</p>

<p>
Las consultas realizadas a través de la plataforma son responsabilidad exclusiva del profesional de la salud interviniente. Kaiteki no realiza diagnósticos ni adopta decisiones clínicas.
</p>

<p>
El paciente declara que la información brindada sobre su estado de salud será veraz, completa y actualizada, y que utilizará la plataforma de manera responsable y conforme a la ley.
</p>

<p>
El paciente reconoce que la atención por telemedicina presenta limitaciones y que, ante situaciones de urgencia, deberá recurrir a servicios de atención médica presencial.
</p>

<p>
Los honorarios, condiciones de pago, cancelación y reembolso serán informados previamente a cada consulta.
</p>

<p>
El paciente autoriza el registro de la información generada durante las consultas en una historia clínica digital, la cual podrá ser consultada únicamente por los profesionales que lo atiendan dentro de la plataforma.
</p>

<p>
De manera excepcional, y siempre con consentimiento previo del paciente y del profesional interviniente, una consulta podrá ser grabada con fines de control de calidad o seguridad.
</p>

<p>
El tratamiento de los datos personales y datos sensibles de salud se rige por la Política de Privacidad de Kaiteki.
</p>

<p>
<strong>📌 Al registrarte, declarás haber leído y aceptado estos términos.</strong>
</p>
		</div>
	)
}

export const BeforePayingTermsAndConditions = () => {
	return (
		<div>
<h2>Antes de continuar, tenga en cuenta que:</h2>

<ul>
  <li>
    La telemedicina tiene limitaciones inherentes, por lo que no siempre puede reemplazar la atención médica presencial. En determinados casos, el profesional podrá indicar la necesidad de una consulta presencial y/o la realización de estudios complementarios.
  </li>
  <li>
    Este servicio <strong>NO</strong> debe ser utilizado en casos de urgencia o emergencia médica (por ejemplo: dolor torácico, dificultad respiratoria severa, pérdida de conciencia, traumatismos graves). Ante estas situaciones, el paciente debe concurrir de inmediato a un servicio de guardia o comunicarse con su sistema de emergencias.
  </li>
  <li>
    La atención, el diagnóstico, la prescripción y las indicaciones médicas realizadas antes, durante o después de la teleconsulta son responsabilidad exclusiva del profesional médico que brinde la atención.
  </li>
  <li>
    Los datos personales y de salud del paciente serán tratados con confidencialidad, conforme a lo dispuesto por la Ley N° 25.326 de Protección de Datos Personales.
  </li>
  <li>
    Kaiteki no asume responsabilidad por fallas derivadas de problemas externos a la plataforma, tales como cortes de energía eléctrica, inconvenientes en la conexión a internet, fallas del dispositivo utilizado u otros factores ajenos a Kaiteki que puedan afectar la consulta.
  </li>
  <li>
    Los pacientes que, por su condición, no puedan realizar una teleconsulta de manera autónoma deberán contar con el acompañamiento de un familiar, tutor o responsable legal durante la misma.
  </li>
  <li>
    El servicio de telemedicina de Kaiteki está destinado a personas mayores de 18 años. En el caso de menores de edad, la consulta deberá ser solicitada y realizada con la presencia de sus padres, tutores o responsables legales.
  </li>
</ul>

<p>
<strong>
Al continuar y realizar el pago, el paciente declara haber leído, comprendido y aceptado estas condiciones para la realización de la teleconsulta a través de Kaiteki.
</strong>
</p>
		</div>
	)
}

// Landing
export const TermsAndConditions = () => {
	return (<>
<h2>Bases y Condiciones de Uso – Kaiteki</h2>

<p><strong>Última actualización:</strong> 1/12/2025</p>

<p>
Las presentes Bases y Condiciones regulan el acceso y uso de la plataforma digital Kaiteki (en adelante, la “Plataforma”), destinada a facilitar el contacto entre pacientes y profesionales de la salud y la gestión de consultas médicas a distancia, mediante herramientas tecnológicas.
</p>

<p>
El uso de la Plataforma implica la aceptación plena de estas Bases y Condiciones y de la Política de Privacidad.
</p>

<h2>1. Objeto de la Plataforma</h2>

<p>Kaiteki es una plataforma digital que permite:</p>

<ul>
  <li>Facilitar el acceso de pacientes a profesionales de la salud.</li>
  <li>Gestionar y coordinar consultas médicas a distancia.</li>
  <li>Integrar servicios externos de videoconferencia y medios de pago.</li>
</ul>

<p>
Kaiteki no actúa como prestador de servicios médicos, sino como una plataforma digital que facilita el acceso a consultas médicas realizadas por profesionales de la salud independientes. Los diagnósticos, indicaciones, prescripciones y demás decisiones clínicas son responsabilidad exclusiva de los profesionales intervinientes.
</p>

<h2>2. Usuarios</h2>

<p>Pueden utilizar la Plataforma:</p>

<ul>
  <li>Pacientes que soliciten una consulta médica a distancia.</li>
  <li>Profesionales de la salud debidamente registrados y validados.</li>
</ul>

<p>
El uso está destinado a personas mayores de edad o a menores bajo la supervisión de un adulto responsable.
</p>

<h2>3. Registro y uso de la cuenta por parte del usuario</h2>

<p>
Para acceder a las funcionalidades de la Plataforma, como buscar un profesional y solicitar una consulta, el usuario deberá registrarse proporcionando información veraz y actualizada.
</p>

<p>El usuario es responsable de:</p>

<ul>
  <li>Mantener la confidencialidad de sus credenciales de acceso (por ejemplo, usuario y contraseña).</li>
  <li>Todas las actividades realizadas desde su cuenta en la Plataforma.</li>
  <li>Notificar por los canales disponibles a la Plataforma ante cualquier uso no autorizado, pérdida o sospecha de vulneración de seguridad de su cuenta.</li>
</ul>

<h2>4. Consultas médicas</h2>

<p>Las consultas realizadas a través de la Plataforma:</p>

<ul>
  <li>No están destinadas a situaciones de urgencia.</li>
  <li>No reemplazan la atención médica presencial cuando esta sea necesaria.</li>
</ul>

<p>
El profesional indicará al paciente cuando corresponda concurrir a una guardia u otro centro asistencial.
</p>

<h2>5. Profesionales de la salud</h2>

<p>
Los profesionales actúan de manera independiente y conservan plena autonomía y responsabilidad profesional.
</p>

<p>
Son responsables de los actos médicos realizados durante la consulta, incluyendo diagnósticos, indicaciones, prescripciones y solicitudes de estudios.
</p>

<p>
El profesional se compromete a ejercer la medicina conforme a las normas éticas y legales vigentes, mantener la confidencialidad de la información del paciente y recomendar atención presencial cuando la situación clínica lo requiera.
</p>

<h2>6. Obligaciones del paciente</h2>

<p>El paciente se compromete a:</p>

<ul>
  <li>Brindar información veraz, completa y actualizada sobre su estado de salud.</li>
  <li>Utilizar la Plataforma de manera responsable y conforme a estas Bases y Condiciones.</li>
  <li>Comprender y respetar las indicaciones brindadas por el profesional de la salud, asumiendo la responsabilidad por las decisiones que adopte respecto de su tratamiento.</li>
  <li>Comprender las limitaciones propias de la atención médica a distancia.</li>
</ul>

<h2>7. Historia clínica digital</h2>

<p>
La Plataforma dispone de una historia clínica digital que permite el registro y la consulta de información médica por parte de los profesionales que atiendan al mismo paciente, con el objetivo de favorecer la continuidad de la atención.
</p>

<p>
El acceso a dicha información se encuentra limitado a los profesionales intervinientes y se rige por el secreto profesional, la normativa vigente y la Política de Privacidad.
</p>

<h2>8. Videoconsultas y servicios de terceros</h2>

<p>
Las videoconsultas se realizan mediante herramientas de terceros (como Google Meet).
</p>

<p>
La Plataforma no graba ni almacena las consultas de manera habitual. De manera excepcional, algunas consultas podrán ser grabadas con fines de control de calidad o mejora del servicio, previo aviso y consentimiento expreso del paciente y del profesional.
</p>

<p>
Los servicios de terceros se rigen por sus propias políticas y condiciones.
</p>

<p>
La Plataforma no garantiza la disponibilidad ininterrumpida del servicio, el cual puede verse afectado por tareas de mantenimiento, fallas técnicas, problemas de conectividad o interrupciones propias de servicios de terceros. Asimismo, la Plataforma no es responsable por problemas técnicos o de conectividad que presente el usuario durante la consulta.
</p>

<h2>9. Pagos</h2>

<p>
El paciente abona la consulta a través de los medios de pago habilitados en la Plataforma.
</p>

<p>
El pago de la consulta es condición necesaria para la reserva del turno.
</p>

<p>
Kaiteki percibe un porcentaje por el uso de la Plataforma y los servicios tecnológicos asociados.
</p>

<p>
Los honorarios correspondientes a la consulta serán informados previamente.
</p>

<p>
Cada profesional es responsable del cumplimiento de sus obligaciones fiscales conforme a la normativa vigente.
</p>

<p>
Las condiciones de cancelación y reprogramación serán informadas al momento de la reserva.
</p>

<h2>10. Suspensión o cancelación de cuentas</h2>

<p>Kaiteki podrá suspender o cancelar cuentas que:</p>

<ul>
  <li>Incumplan estas Bases y Condiciones.</li>
  <li>Realicen un uso indebido de la Plataforma.</li>
  <li>Afecten la seguridad o el correcto funcionamiento del servicio.</li>
</ul>

<h2>11. Modificaciones</h2>

<p>
Kaiteki podrá modificar estas Bases y Condiciones, publicando las actualizaciones en el sitio web.
</p>

<h2>12. Legislación aplicable</h2>

<p>
Estas Bases y Condiciones se rigen por la legislación vigente en la República Argentina.
</p>

<h2>13. Contacto</h2>

<p>
Para consultas relacionadas con estas Bases y Condiciones:
</p>

<p>
<a href="mailto:contacto@kaitekisalud.com">contacto@kaitekisalud.com</a>
</p>

	</>)
}

export const TermsAndConditionsPage = () => {
	return (
		<div style={{margin: '40px'}}>
			<TermsAndConditions />
		</div>
	)
}

// Landing
export const PrivacyPolicy = () => {
	return (
	<>
		<h2>Política de Privacidad – Kaiteki</h2>

<p><strong>Última actualización:</strong> 30/12/2025</p>

<p>
En Kaiteki (en adelante, "la Plataforma") valoramos y protegemos la privacidad y confidencialidad de la información de pacientes y profesionales que utilizan la plataforma. La presente Política de Privacidad describe cómo Kaiteki recopila, utiliza, almacena y protege los datos personales y médicos de las personas que utilizan la plataforma, incluyendo pacientes y profesionales de la salud.
</p>

<p>
Al utilizar la plataforma, el usuario acepta las prácticas aquí descriptas.
</p>

<h2>1. Alcance</h2>

<p>
Esta Política aplica a todos los usuarios de la Plataforma, incluyendo pacientes, profesionales de la salud y cualquier otra persona que se registre o interactúe con el Servicio.
</p>

<h2>2. Información que recopilamos</h2>

<h3>2.1 Datos personales</h3>

<ul>
  <li>Nombre y apellido</li>
  <li>Documento de identidad</li>
  <li>Correo electrónico y teléfono</li>
  <li>Otros datos necesarios para la gestión del servicio (p.ej. obra social para confeccionar una orden médica)</li>
</ul>

<h3>2.2 Datos profesionales (médicos)</h3>

<ul>
  <li>Matrícula profesional</li>
  <li>Especialidad</li>
  <li>Información necesaria para la validación profesional</li>
</ul>

<h3>2.3 Información médica y asistencial</h3>

<p>
La Plataforma puede almacenar información médica generada durante las consultas, que forma parte de una historia clínica digital dentro de la plataforma, incluyendo motivo de consulta, evoluciones clínicas e indicaciones médicas.
</p>

<p>
La historia clínica digital podrá ser consultada por otros profesionales que atiendan al mismo paciente dentro de la Plataforma, con el objetivo exclusivo de garantizar la continuidad y calidad de la atención, y bajo las normas éticas y legales aplicables.
</p>

<h3>2.4 Información técnica</h3>

<p>
Datos técnicos básicos vinculados al uso de la plataforma (por ejemplo, tipo de dispositivo o navegador).
</p>

<h2>3. Finalidad del tratamiento de datos</h2>

<p>La información recopilada se utiliza exclusivamente para:</p>

<ul>
  <li>Brindar servicios de telemedicina</li>
  <li>Gestionar turnos y consultas</li>
  <li>Facilitar la comunicación entre pacientes y profesionales</li>
  <li>Garantizar la continuidad asistencial</li>
  <li>Enviar notificaciones relacionadas con el servicio</li>
  <li>Mejorar el funcionamiento de la plataforma</li>
  <li>Cumplir con obligaciones legales</li>
</ul>

<h2>4. Rol de la plataforma</h2>

<p>
Kaiteki es una plataforma digital que facilita el acceso a profesionales de la salud y la gestión de consultas médicas a distancia, poniendo en contacto a pacientes y médicos a través de herramientas tecnológicas.
</p>

<p>
Los actos médicos son realizados exclusivamente por los profesionales intervinientes, quienes conservan plena autonomía y responsabilidad profesional.
</p>

<h2>5. Videoconsultas, grabaciones y servicios de terceros</h2>

<p>La Plataforma puede integrar servicios de terceros como:</p>

<ul>
  <li>Google (videollamadas, autenticación)</li>
  <li>Servicios de mensajería</li>
  <li>Billeteras digitales como Mercado Pago para pagos</li>
</ul>

<p>
El uso de dichas herramientas se encuentra sujeto a sus propias políticas de privacidad.
</p>

<p>
Las videoconsultas se realizan mediante herramientas de terceros (como Google Meet).
</p>

<p>
La Plataforma no graba ni almacena las videollamadas de manera habitual. De manera excepcional, algunas consultas podrán ser grabadas con fines de control de calidad, auditoría o mejora del servicio. En dichos casos, el paciente y el profesional serán informados previamente, y la grabación solo se realizará con su consentimiento expreso. Las grabaciones, en caso de existir, serán tratadas de forma confidencial, con acceso restringido, por un plazo limitado y no se utilizarán con fines comerciales ni publicitarios.
</p>

<h2>6. Confidencialidad y seguridad</h2>

<p>
La Plataforma adopta medidas técnicas y organizativas razonables para proteger los datos personales y médicos.
</p>

<p>
Los profesionales de la salud que utilizan la plataforma se comprometen a cumplir con las normas éticas y legales aplicables al ejercicio de la medicina y a la protección de los datos de los pacientes según las normativas vigentes (Ley N° 25.326).
</p>

<h2>7. Compartición de información</h2>

<p>
La Plataforma no vende ni comercializa datos personales o médicos.
</p>

<p>La información solo se comparte:</p>

<ul>
  <li>Entre paciente y profesionales involucrados en su atención</li>
  <li>Con proveedores tecnológicos bajo acuerdos de confidencialidad</li>
  <li>Cuando la ley o una autoridad competente lo exija</li>
</ul>

<h2>8. Conservación de los datos</h2>

<p>
Los datos serán conservados mientras exista una relación activa con el usuario o conforme lo requiera la normativa aplicable.
</p>

<h2>9. Derechos de los usuarios</h2>

<p>
El usuario puede solicitar el acceso, rectificación o eliminación de sus datos personales y médicos, conforme a la legislación vigente en la República Argentina.
</p>

<h2>10. Privacidad de menores</h2>

<p>
Los menores de edad que utilicen la plataforma deben estar acompañados de un adulto responsable.
</p>

<h2>11. Modificaciones</h2>

<p>
La Plataforma podrá actualizar esta Política de Privacidad. Las modificaciones que se realicen serán publicadas en el sitio web.
</p>

<h2>12. Contacto</h2>

<p>
Para consultas sobre privacidad o datos personales:
</p>

<p>
<a href="mailto:contacto@kaitekisalud.com">contacto@kaitekisalud.com</a>
</p>

	</>
)}

export const PrivacyPolicyPage = () => {
	return (
		<div style={{margin: '40px'}}>
			<PrivacyPolicy />
		</div>
	)
}